import { DAILYUPDATE_ADD, DAILYUPDATE_LIST, DAILYUPDATE_BYID_PERQUATER } from "./ActionType"

const initialValue = {
    createDailyUpdate: null,
    dailyUpdateDetails: [],
    dailyUpdatebyIdPerQuarter: [],
}

export const dailyUpdateReducer = (store = initialValue, { type, payload }) => {

    if (type === DAILYUPDATE_ADD) {
        return { ...store, createDailyUpdate: payload }
    } else if (type === DAILYUPDATE_LIST) {
        return {
            ...store,
            dailyUpdateDetails: payload || [],
        };
    } else if (type === DAILYUPDATE_BYID_PERQUATER) {
        return {
            ...store,
            dailyUpdatebyIdPerQuarter: payload || [],
        };
    }


    return store
}